import React, { useState } from "react";
import Navbar from "../navbar";
import Footer from "../footer";
import { Link } from "gatsby";
import "./style.scss";
import ActionPopup from "../actionpopup";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function ProductCategory2({ category }) {
  const {
    categoryName,
    description,
    benefits,
    products,
    brochureLink,
    actionToAccess = true,
    banner,
    bannerSm,
    pattern,
  } = category;

  const [showActionToAccess, setShowActionToAccess] = useState(false);

  return (
    <div className="productcategory2">
      <Navbar />
      {banner && (
        <img
          className="productcategory2__banner desktop"
          alt="Category Banner"
          src={banner}
        ></img>
      )}
      {bannerSm && (
        <img
          className="productcategory2__banner mobile"
          alt="Category Banner"
          src={bannerSm}
        ></img>
      )}
      <div className="productcategory2__content">
        <div
          className="productcategory2__descriptioncontainer"
          style={
            {
              // background: pattern ? `url("${pattern}")` : "",
              // backgroundSize: "cover !important",
            }
          }
        >
          <h1 className="heading-primary">{categoryName}</h1>
          <p className="productcategory2__description">{description}</p>

          <div className="productcategory2__topcontainer">
            {benefits && benefits.length > 0 && (
              <>
                <h3 className="productcategory2__benefits">Benefits</h3>
                <ul className="productcategory2__benefits__list">
                  {benefits.map((item, i) => (
                    <li className="productcategory2__benefits__list__item">
                      {item}
                    </li>
                  ))}
                </ul>
              </>
            )}
            <ActionPopup
              link={brochureLink}
              category={categoryName}
              showPopup={showActionToAccess}
              onClose={() => {
                setShowActionToAccess(false);
              }}
            />
            <div className="productcategory2__buttons">
              {actionToAccess ? (
                <div
                  onClick={() => setShowActionToAccess(true)}
                  className="btn-primary"
                >
                  Brochure <i class="fas fa-download"></i>
                </div>
              ) : (
                <a
                  href={brochureLink}
                  className="btn-primary"
                  target="_blank"
                  download
                >
                  Brochure <i class="fas fa-download"></i>
                </a>
              )}
            </div>
          </div>
        </div>
        {/* <div className="productcategory2__models">Models</div> */}

        <div className="productcategory2__productscontainer">
          <div className="row">
            {products.map((product, i) => (
              <div className="col col-12 col-md-6 col-lg-4">
                {/* <Link to={product.link}> */}
                <div
                  // style={{ backgroundColor: color }}
                  className="productcategory2__product"
                >
                  <img
                    alt="product image"
                    className="productcategory2__product__img"
                    src={product.img}
                  />
                  <div className="productcategory2__product__name">
                    {product.name}
                  </div>
                  <div className="productcategory2__product__description">
                    {/* Reprehenderit eiusmod elit eiusmod proident. Sint consequat
                    laborum culpa nisi quis non magna laboris et dolor dolor
                    enim cillum irure. */}
                  </div>
                  <div className="productcategory2__product__startingat">
                    <strong>Starting at: </strong>
                    {product.startingAt}
                  </div>
                  <Link className="btn-primary" to={product.link}>
                    Explore
                  </Link>
                </div>

                {/* </Link> */}
              </div>
            ))}
          </div>
        </div>
        <div className="productcategory2__nearretailer">
          <div className="productcategory2__nearretailer__box">
            <h2>Find a retailer near you</h2>
            {/* <br /> */}
            <Link to="/exclusive-stores/">Exclusive Stores</Link>
            <Link to="/retail-stores/">Retail Stores</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
